var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-lg-none"},[(!_vm.hideFooter)?_c('mobile-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }